export default __webpack_public_path__ + "static/media/start_bg.d7da8556.jpg";